module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Pouch":"Pouch","(max. 50 gold coin)":"(max. 50 coin)"},"fr":{"Pouch":"Bourse","(max. 50 gold coin)":"(50 pièces max)"}}')
  delete Component.options._Ctor
}
